import React from 'react';

import { ISelectionCard } from '../../../../interfaces/cards';
import BdsCircleIndicatorPictogram from '../../BdsCircleIndicator/BdsCircleIndicatorPictogram/BdsCircleIndicatorPictogram';
import BdsRadioButton from '../../BdsRadioButton/BdsRadioButton';
import BdsCardContainer from '../BdsCardContainer/BdsCardContainer';
import './SelectionCard.scss';

const SelectionCard = ({
  type,
  name,
  onChange,
  selected,
  value,
  description,
  className,
  title,
  disabled,
  pictogram,
  radiusSize,
  paddingSize
}: ISelectionCard) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(value);
    }
  };

  const classNameContainer = ['selection-card-container', className, disabled ? 'disabled' : '', type].join(' ');

  return (
    <BdsCardContainer
      onClick={handleClick}
      className={classNameContainer}
      paddingSize={paddingSize}
      borderRadiusSize={radiusSize}
    >
      <div className="selection-card">
        <div className="selection-card-top-content">
          <BdsCircleIndicatorPictogram
            className={`selection-card-circle-indicator-pictogram ${disabled ? 'disabled' : ''}`}
            circleIndicatorSize="s"
            pictogram={pictogram}
          />
          <BdsRadioButton
            name={name}
            onChange={onChange}
            selected={selected}
            value={value}
            variant="primary"
            disabled={disabled}
          />
        </div>
        <div className="selection-card-information-content">
          <div className="selection-card-information-content-title">{title}</div>
          <div className="selection-card-information-content-description">{description}</div>
        </div>
      </div>
    </BdsCardContainer>
  );
};
export default SelectionCard;
